module.exports = __webpack_public_path__ + "static/media/shape.68787e71.svg";